import { Component } from '@opten/compiler/metadata/component';
import {IFramePlayer} from '@opten/player';

@Component({ className: 'js-player', observe: true })
export class IFramePlayerComponent {
	constructor(private element: HTMLElement) {
		new IFramePlayer(element);
	}
}